const de = {
  title: 'Veranstaltungen',
  detailTitle: 'Veranstaltung',
  registration: 'Registrierung',
  waitingListLength: 'Wartelistenlänge',
  eventTimeSpan: 'Findet zu folgendem Zeitraum statt:',
  eventDate: 'Datum:',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  cancelled: 'Abgesagt',
  moveToGroup: 'Verschieben in Gruppe',
  ended: 'Beendet',
  notSpecified: 'Nicht angegeben',
  addParticipant: 'Teilnehmer hinzufügen',
  preCalculated:
    'Aktuell wird die vorläufig berechnete Teilnehmerliste angezeigt. Die Teilnehmerliste kann sich noch bis zum Ende der Registrierung verändern.',
  groupWithoutInfo: 'Gruppe ohne Info',
  create: {
    steps: {
      organization: 'Organisation',
      informations: 'Informationen',
      groups: 'Gruppen',
      preview: 'Vorschau'
    },
    title: 'Neue Veranstaltung',
    editTitle: 'Veranstaltung bearbeiten',
    eventName: 'Titel',
    description: 'Beschreibung',
    date: 'Datum',
    authorRole: 'Autorenrolle',
    host: 'Veranstalter',
    lecturer: 'Dozent',
    organizer: 'Bearbeitende Rollen',
    organizingPersons: 'Weitere Bearbeiter',
    organizingPersonsPlaceholder: 'Bitte Email eingeben',
    occupancy: 'Auslastung',
    waitingList: 'Warteliste',
    partListVisible: 'Teilnehmerliste sichtbar',
    isUnenrollAfterRegPeriodPossible: 'Abmeldung nach Registrierungsende',
    visibleFrom: 'Sichtbar ab',
    regPeriodEnd: 'Ende des Registrierungszeitraums',
    regPeriodStart: 'Start des Registrierungszeitraums',
    startDate: 'Start der Veranstaltung',
    endDate: 'Ende der Veranstaltung',
    attachment: 'Anhang',
    calendarInviteTitle: 'Kalendereinladung',
    calendarInviteText: 'Soll eine Kalendereinladung für diese Veranstaltung versendet werden?',
    attachmentPlaceholder: 'Anhang hochladen',
    waitingListTypes: {
      NONE: 'Keine Warteliste',
      GROUP: 'Jede Gruppe hat eine Warteliste',
      EVENT: 'Eine Warteliste für die gesamte Veranstaltung'
    },
    priorization: 'Priorisierung',
    priorizationType: {
      SEMESTER: 'Priorisierung nach Semester in absteigender Reihenfolge',
      DATE: 'Priorisierung nach Anmeldedatum in aufsteigender Reihenfolge'
    },
    groupManagement: 'Gruppenverwaltung',
    sameGroupSize: 'Einheitliche Gruppengröße',
    maxParticipants: 'Maximale Anzahl an Teilnehmern',
    minParticipants: 'Minimale Anzahl an Teilnehmern',
    addNewGroupButton: 'Neue Gruppe hinzufügen',
    groupCard: {
      group: 'Gruppe',
      place: 'Ort',
      info: 'Info',
      date: 'Datum',
      maxParticipants: 'Maximale Anzahl an Teilnehmern',
      minParticipants: 'Minimale Anzahl an Teilnehmern',
      participants: 'Teilnehmer',
      currently: 'Aktuell',
      currentlyPreCalc: 'Aktuell (vorläufig)',
      min: 'Minimum',
      max: 'Maximum',
      peopleInWaitinglist: 'Personen in der Warteliste',
      peopleInWaitinglistPreCalc: 'Personen in der Warteliste (vorläufig)'
    },
    maxParticipantIncreasePromotionInfo:
      'Die maximale Anzahl an Teilnehmern wurde erhöht.\n Personen aus der Warteliste werden nachrücken.'
  },
  cancelModal: {
    headline: 'Absagen der Gruppe:',
    howToCancel: 'Wie soll die Gruppe abgesagt werden?',
    complete: 'Vollständig',
    automatic: 'Teilnehmer werden automatisch verteilt',
    manually: 'Teilnehmer werden manuell verteilt'
  },
  filter: {
    occupancy: 'Nach Auslastung filtern',
    host: 'Veranstalter',
    enrolled: 'Angemeldet',
    onWaitingList: 'inkl. auf Warteliste',
    showAll: 'Alle Veranstaltungen',
    showAllMobile: 'Alle',
    myEvents: 'Meine Veranstaltungen',
    myEventsMobile: 'Meine'
  },
  tooltips: {
    mail: 'Mailversand',
    createEventArticle: 'Beitragsverknüpfung',
    participantListVisible: 'Wenn ausgewählt, ist die Teilnehmerliste für alle Teilnehmer sichtbar',
    isUnenrollAfterRegPeriodPossible:
      'Ist dies aktiviert, können sich Teilnehmer nach Registrierungsende noch selbst von der Veranstaltung abmelden. Es werden keine Personen automatisch von der Warteliste nachrücken.',
    attachments: 'Anhänge',
    enroll: 'Zur Veranstaltung anmelden',
    unenroll: 'Von Veranstaltung abmelden',
    refresh: 'Aktualisieren',
    exports: 'Datei-Exporte',
    edit: 'Veranstaltung bearbeiten',
    copy: 'Veranstaltung kopieren',
    delete: 'Veranstaltung löschen',
    cancel: 'Veranstaltung absagen',
    showAll: 'Alle Veranstaltungen inklusive vergangener und abgesagter Veranstaltungen',
    myEvents: 'Alle Veranstaltungen welche Sie bearbeiten dürfen',
    occupancy: 'Die prozentuale Belegung der Teilnehmer',
    waitingList:
      'Wenn Priorisierung nach Semester ausgewählt ist, muss eine Warteliste ausgewählt werden, da die Verteilung erst nach dem Registrierungszeitraum passiert.',
    organizingRoles:
      'Personen mit einer der ausgewählten Rollen dürfen die Veranstaltung komplett bearbeiten',
    oneWaitingListForEvent:
      'Wenn diese Option gewählt ist, kann man sich nur für die Veranstaltung und nicht für einzelne Gruppen anmelden. Die Gruppen werden dann zufällig aufgefüllt',
    dataProtectionCreatedAt:
      'Aus Datenschutzgründen wird lediglich der eigene Eintragungszeitpunkt angezeigt',
    enrollTooEarly: 'Der Registrierungszeitraum hat noch nicht begonnen.',
    maxParticipantsTooltip:
      'Die maximale Anzahl kann nach dem Beginn des Registrierungszeitraums nicht mehr verringert werden.',
    calendarInvite:
      'Je nach gewählter Priorisierung, wird die Einladung entweder direkt nach Anmeldung oder nach Ende des Registrierungszeitraums versendet.'
  },
  sortOptions: {
    newest: 'Neueste zuerst',
    startDate: 'Startdatum',
    title: 'Veranstaltungstitel',
    host: 'Veranstalter'
  },
  alerts: {
    errorLoading: 'Die Veranstaltungserstellung konnte nicht geladen werden',
    failedCreate: 'Die Veranstaltung konnte nicht erfolgreich erstellt werden',
    failedUpdate: 'Die Veranstaltung konnte nicht erfolgreich bearbeitet werden',
    failedAttachmentUpload: 'Der Anhang konnte nicht erfolgreich hochgeladen werden',
    failedLoadEvent: 'Die Veranstaltung konnte nicht geladen werden',
    failedDelete: 'Die Veranstaltung konnte nicht gelöscht werden',
    failedCancel: 'Die Veranstaltung konnte nicht abgesagt werden',
    failedGroupCancel: 'Die Gruppe konnte nicht abgesagt werden',
    failedEnrollment:
      'Sie konnten nicht für die Veranstaltung angemeldet werden. Möglicherweise ist die Gruppe oder Veranstaltung bereits voll.',
    failedEnrollmentForPreconditionFailed:
      'Sie konnten nicht für die Veranstaltung angemeldet werden. Möglicherweise ist die Veranstaltung bereits beendet oder abgesagt.',
    failedEnrollmentTooEarly:
      'Sie konnten nicht für die Veranstaltung angemeldet werden, da der Registrierungszeitraum noch nicht gestartet hat.',
    failedUnenrollment: 'Sie konnten nicht aus der Veranstaltung ausgeschrieben werden',
    failedUnenroll: 'Das Ausschreiben hat nicht funktioniert',
    failedArticleCreation:
      'Der Veranstaltungsbeitrag konnte nicht erstellt werden. Ein Problem kann sein, dass die Dauer der Veranstaltung unter einer Stunde ist.',
    successfulCreate: 'Die Veranstaltung wurde erfolgreich erstellt',
    successfulUpdate: 'Die Veranstaltung wurde erfolgreich bearbeitet',
    successfulDelete: 'Die Veranstaltung wurde gelöscht',
    successfulCancel: 'Die Veranstaltung wurde abgesagt',
    successfulGroupCancel: 'Die Gruppe wurde abgesagt',
    successfulEnrollment: 'Sie sind nun an der Veranstaltung angemeldet',
    successfulUnenrollment: 'Sie sind nun von der Veranstaltung abgemeldet',
    successfulEnrollmentToWaitingList:
      'Da alle Plätze bereis voll sind, wurden Sie in die Warteliste eingetragen',
    successfulEnrollmentToWaitingListForSemester:
      'Sie sind nun in die Warteliste eingetragen, die Zuweisung der Teilnehmer erfolgt bei dieser Veranstaltung erst nach Ablauf der Registrierungsfrist',
    successfulUnenrollmentFromWaitingList: 'Sie wurden aus der Warteliste entfernt.',
    successfulArticleCreation: 'Ein Veranstaltungs Beitrag wurde erfolgreich erstellt.'
  },
  confirmationDialog: {
    deleteEventWarning: 'Wollen Sie die Veranstaltung wirklich löschen?',
    cancelEventWarning: 'Wollen Sie die Veranstaltung wirklich absagen?',
    deleteEventInformation: 'Die Veranstaltung wird hiermit unwiderruflich gelöscht.',
    cancelEventInformation:
      'Die Veranstaltung wird hiermit unwiderruflich abgesagt.\n Alle Teilnehmer und Personen auf der Warteliste werden per Mail darüber informiert.',
    enrollTitle: 'Bitte bestätigen Sie, dass Sie an der Veranstaltung teilnehmen möchten',
    enrollText: 'Sie können sich jederzeit wieder aus der Veranstaltung austragen.',
    unenrollTitle: 'Bitte bestätigen Sie, dass Sie sich aus der Veranstaltung austragen möchten',
    unenrollText: 'Sie können sich jederzeit wieder in die Veranstaltung eintragen.',
    unenrollUserTitle:
      'Bitte bestätigen Sie, dass Sie den Nutzer aus der Veranstaltung austragen möchten',
    unenrollUserText:
      'Der Benutzer erhält eine Benachrichtigung, dass er aus der Veranstaltung ausgetragen wurde.',
    createArticleTitle: 'Beitragserstellung',
    createArticleText:
      'Bitte bestätigen Sie, dass Sie einen Beitrag aus dieser Veranstaltung erstellen möchten.'
  },
  eventDetailPage: {
    backToListEventView: 'Zurück zur Veranstaltungsübersicht',
    eventInformation: 'Veranstaltungsinformationen',
    registrationFrom: 'Ab',
    registrationUntil: 'Bis',
    hostedBy: 'Veranstaltet von',
    organizingAuthorgroups: 'Organisierende Autorengruppen',
    organizingUsers: 'Organisierende Benutzer',
    organizer: 'Veranstalter',
    enrollments: 'Anmeldungen',
    maxParticipants: 'Max. Teilnehmer',
    minParticipants: 'Min. Teilnehmer',
    actualNumberOfParticipants: 'Aktuelle Anzahl an Teilnehmern',
    waitingListExists: 'Warteliste vorhanden',
    admissionCriteria: 'Teilnahmeinformationen',
    groupOverview: 'Gruppenübersicht',
    enrollmentOverviewSwitchToDesktopInfo:
      'Um die Teilnehmerliste und Warteliste zu sehen, bitte auf die Desktop Ansicht des Dashboards wechseln.',
    participatingEntitlements: 'Empfänger',
    participatingSemesters: 'Teilnehmende Semester',
    placement: 'Platzierung',
    timeOfEnrollment: 'Eintragungszeitpunkt',
    waitingListTypes: {
      NONE: 'Keine Warteliste',
      GROUP: 'Jede Gruppe hat eine Warteliste',
      EVENT: 'Eine Warteliste für die gesamte Veranstaltung'
    },
    priorizationType: {
      SEMESTER: 'Priorisierung nach Semester in absteigender Reihenfolge',
      DATE: 'Priorisierung nach Anmeldedatum in aufsteigender Reihenfolge'
    },
    export: {
      exportSignature: 'Exportiere die Unterschriftenliste',
      exportEvent: 'Exportiere die Veranstaltung'
    },
    participantInfos: {
      status: 'Status',
      statusPreCalc: 'Status (vorläufig)',
      position: 'Position',
      group: 'Gruppe',
      participantStates: {
        waitingList: 'Warteliste',
        participant: 'Angemeldet'
      }
    },
    mail: {
      toParticipants: 'Sende eine Mail an alle Teilnehmer',
      toPreCalcParticipants: 'Sende eine Mail an alle vorläufigen Teilnehmer',
      toWaitingList: 'Sende eine Mail an alle Personen auf der Warteliste',
      toPreCalcWaitingList: 'Sende eine Mail an alle Personen auf der vorläufigen Warteliste'
    }
  }
};

export default de;
export type Translation = typeof de;
